// 后台登录态统一读写。
// 历史遗留：除了 token / user，还额外存了一个 isLogin 标记（Login.vue 里写入）。
// 现在一律以「token 存在且未过期」为准，isLogin 仅为兼容旧版页面保留，不再作为判断依据。

const TOKEN_KEY = 'token'
const USER_KEY = 'user'
const LOGIN_KEY = 'isLogin'

export function getToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

// 只解析 JWT 的 payload 读 exp，不做签名校验。
// 签名与吊销（tokenVersion）由后端判定，前端解析只是为了「提前」发现过期，
// 避免带着一个必然 401 的 token 去渲染页面。
export function readJwtPayload (token) {
  const parts = String(token || '').split('.')
  if (parts.length !== 3) return null
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    const json = decodeURIComponent(
      atob(padded)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )
    return JSON.parse(json)
  } catch (e) {
    return null
  }
}

export function isTokenExpired (token) {
  const payload = readJwtPayload(token)
  // 解析不出 exp 就当作有效，交给后端返回 401 再处理
  if (!payload || !payload.exp) return false
  return payload.exp * 1000 <= Date.now()
}

export function isLoggedIn () {
  const token = getToken()
  if (!token) return false
  if (isTokenExpired(token)) {
    clearAuth()
    return false
  }
  return true
}

export function saveAuth (token, user) {
  localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user || null))
  localStorage.setItem(LOGIN_KEY, 'true')
}

export function clearAuth () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(LOGIN_KEY)
}

// 当前页面的完整路径（含查询串），登录后跳回来用
export function currentPath () {
  return window.location.pathname + window.location.search
}
